var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 95.793,
    height: 89.927,
    viewBox: "0 0 95.793 89.927",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1843",
    "data-name": "Rectangle 1843",
    width: 95.793,
    height: 89.927,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22024",
    "data-name": "Group 22024",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M0,37.1c.307-1.929.535-3.873.934-5.783a39.839,39.839,0,0,1,77.733-.491,38.4,38.4,0,0,1,.841,12.7,1.7,1.7,0,0,1-1.741,1.7,1.677,1.677,0,0,1-1.609-1.9c.018-.589.078-1.176.13-1.919H75.274q-3.461,0-6.923,0c-1.344,0-2.127-.632-2.109-1.687s.8-1.66,2.159-1.662q3.415-.006,6.829,0h1a36.354,36.354,0,0,0-34.7-34.644V7.217c0,1.494.006,2.988,0,4.482-.006,1.207-.637,1.953-1.645,1.972-1.034.02-1.706-.756-1.71-2.008-.007-2.428,0-4.856,0-7.283V3.461c-17.612.254-34.164,15.447-34.7,34.577H7.287c1.528,0,3.056-.012,4.584,0a1.68,1.68,0,1,1,.02,3.345c-2.463.015-4.927,0-7.39,0H3.488c.387,18.479,16.4,34.226,34.67,34.629q0-3.258,0-6.515c0-.623-.009-1.245,0-1.867a1.642,1.642,0,0,1,1.67-1.829,1.661,1.661,0,0,1,1.679,1.837c.019,2.147.006,4.3.006,6.443,0,.646,0,1.291,0,2.025.906-.068,1.7-.14,2.5-.185,1.2-.066,1.929.453,2.029,1.428.11,1.067-.553,1.782-1.811,1.911a38.808,38.808,0,0,1-21.714-3.762C10.5,69.5,3.24,59.806.62,46.653.336,45.226.2,43.769,0,42.326V37.1",
    transform: "translate(0 0)",
    fill: "#434db8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M235.9,225.631a1.675,1.675,0,0,0-.166.317,5.554,5.554,0,0,1-5.775,4.331c-8.01-.09-16.019-.2-24.029-.3-4.488-.054-8.977-.061-13.464-.148a5.517,5.517,0,0,1-5.674-4.452,5.829,5.829,0,0,1,.956-4.434q5.8-9.306,11.556-18.635,3.785-6.107,7.571-12.213c2.608-4.195,7.636-4.115,10.091.163q8.939,15.573,17.861,31.157c.425.743.718,1.562,1.073,2.345Zm-24.613.887v.41q9.255,0,18.51,0c2.416,0,3.4-1.622,2.2-3.707q-8.977-15.656-17.967-31.305c-1.2-2.083-3.051-2.1-4.323-.043q-7.938,12.806-15.874,25.613c-1.13,1.824-2.278,3.637-3.384,5.476a2.212,2.212,0,0,0,1.861,3.533c.279.02.561.019.841.019h18.135",
    transform: "translate(-140.108 -140.352)",
    fill: "#f8981c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M141.807,77.251c0-2.458-.005-4.916,0-7.373,0-1.212.628-1.967,1.62-1.995,1.027-.029,1.725.752,1.728,2q.014,7.373-.008,14.747a1.14,1.14,0,0,0,.77,1.256,4.658,4.658,0,0,1,2.527,2.744.948.948,0,0,0,1.091.713c3.3,0,6.607.035,9.911.058.187,0,.375-.007.561.006a1.735,1.735,0,0,1,1.769,1.686,1.68,1.68,0,0,1-1.863,1.65c-2.774,0-5.548-.029-8.322-.046-.156,0-.312,0-.467-.007-1.491-.108-2.68-.023-3.736,1.514-1.279,1.863-3.444,2.23-5.642,1.515a5.261,5.261,0,0,1-3.644-4.736,5.147,5.147,0,0,1,2.939-5.1,1.188,1.188,0,0,0,.777-1.255c-.036-2.457-.014-4.915-.014-7.373m1.67,15.428a2.1,2.1,0,0,0,2.051-2.019,2.042,2.042,0,1,0-2.051,2.019",
    transform: "translate(-103.648 -50.948)",
    fill: "#434db8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M212.691,47.59c-1.445-.022-2.3-1.238-1.791-2.3a29.066,29.066,0,0,1,1.847-3.22,1.608,1.608,0,0,1,2.163-.422,1.555,1.555,0,0,1,.69,2,29.474,29.474,0,0,1-1.907,3.29c-.243.361-.79.518-1,.648",
    transform: "translate(-158.177 -31.077)",
    fill: "#434db8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M90.566,40.85a5.842,5.842,0,0,1,1.307,1.024,23.224,23.224,0,0,1,1.556,2.644A1.664,1.664,0,1,1,90.558,46.2c-.558-.895-1.107-1.8-1.584-2.737a1.82,1.82,0,0,1,1.592-2.613",
    transform: "translate(-66.628 -30.659)",
    fill: "#434db8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M46.612,209.571a6.883,6.883,0,0,1,1.363,1.356,1.345,1.345,0,0,1-.509,1.811,32.691,32.691,0,0,1-3.234,1.844,1.3,1.3,0,0,1-1.791-.539c-.262-.5-.428-1.427-.149-1.779,1.041-1.312,2.638-1.857,4.32-2.694",
    transform: "translate(-31.633 -157.291)",
    fill: "#434db8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M259.355,90.754a3.866,3.866,0,0,1-.814,1.07,22.524,22.524,0,0,1-2.647,1.56,1.655,1.655,0,0,1-2.265-.619,1.622,1.622,0,0,1,.605-2.264c.869-.543,1.753-1.069,2.67-1.525a1.709,1.709,0,0,1,2.452,1.778",
    transform: "translate(-190.18 -66.637)",
    fill: "#434db8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M94.145,253.973a5.1,5.1,0,0,1-.295.869c-.477.871-.961,1.74-1.493,2.578a1.653,1.653,0,0,1-2.273.607,1.628,1.628,0,0,1-.624-2.256c.5-.93,1.03-1.844,1.6-2.729a1.412,1.412,0,0,1,1.871-.6,6.2,6.2,0,0,1,1.357,1.319l-.146.209",
    transform: "translate(-66.977 -189.354)",
    fill: "#434db8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M44.324,88.848a2.6,2.6,0,0,1,.567.173c.922.509,1.857,1,2.742,1.571a1.61,1.61,0,0,1,.552,2.2,1.657,1.657,0,0,1-2.252.651c-.906-.474-1.791-.991-2.653-1.541a1.541,1.541,0,0,1-.636-1.882,1.679,1.679,0,0,1,1.68-1.174",
    transform: "translate(-31.934 -66.684)",
    fill: "#434db8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M221.383,236.578H203.248c-.28,0-.562,0-.841-.019a2.212,2.212,0,0,1-1.861-3.533c1.106-1.838,2.254-3.652,3.384-5.476q7.937-12.807,15.874-25.613c1.272-2.053,3.127-2.04,4.323.042q8.99,15.649,17.967,31.305c1.2,2.084.215,3.709-2.2,3.707q-9.255-.009-18.51,0,0-.205,0-.41m1.583-18.791c0-1.77.012-3.54,0-5.31a1.737,1.737,0,0,0-1.695-1.935c-1,.008-1.653.767-1.656,1.958q-.012,5.263,0,10.527c0,1.194.657,1.925,1.678,1.919s1.665-.752,1.674-1.942c.013-1.739,0-3.478,0-5.217M221.3,228.479a1.713,1.713,0,0,0-.039,3.425,1.713,1.713,0,0,0,.039-3.425",
    transform: "translate(-150.203 -150.412)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M153.542,155.024A2.068,2.068,0,0,1,151.51,153a2.042,2.042,0,1,1,4.084.006,2.1,2.1,0,0,1-2.051,2.019",
    transform: "translate(-113.714 -113.293)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M281.57,248.283c0,1.739.01,3.478,0,5.217-.009,1.189-.668,1.936-1.674,1.942-1.021.006-1.675-.725-1.678-1.919q-.011-5.264,0-10.528c0-1.191.66-1.95,1.656-1.958a1.736,1.736,0,0,1,1.695,1.935c.017,1.77,0,3.54,0,5.31",
    transform: "translate(-208.807 -180.908)",
    fill: "#f8981c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M279.92,312.941a1.713,1.713,0,0,1-.039,3.425,1.713,1.713,0,0,1,.039-3.425",
    transform: "translate(-208.825 -234.874)",
    fill: "#f8981c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.1710572aaf0aa075d73cb31109ff644a.svg";
export { ForwardRef as ReactComponent };